"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.meanTransformDependencies = void 0;

var _dependenciesAddGenerated = require("./dependenciesAdd.generated.js");

var _dependenciesDivideGenerated = require("./dependenciesDivide.generated.js");

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var meanTransformDependencies = {
  addDependencies: _dependenciesAddGenerated.addDependencies,
  divideDependencies: _dependenciesDivideGenerated.divideDependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createMeanTransform: _factoriesAny.createMeanTransform
};
exports.meanTransformDependencies = meanTransformDependencies;